import { Phone, MessageCircle, Mail, Globe } from 'lucide-react'

export const getTemperature = (score: number) => {
  if (score >= 80) return { label: 'Quente', color: '#ef4444' }
  if (score >= 50) return { label: 'Morno', color: '#f59e0b' }
  return { label: 'Frio', color: '#0ea5e9' }
}

export const getCanalIcon = (canal: string) => {
  const c = String(canal || '').toUpperCase()
  if (c === 'TELEFONE') return <Phone size={14} />
  if (c === 'WHATSAPP') return <MessageCircle size={14} />
  if (c === 'EMAIL') return <Mail size={14} />
  return <Globe size={14} />
}

export function formatCloserLeadDate(dateStr?: string) {
  if (!dateStr) return '---'
  try {
    return new Date(dateStr).toLocaleDateString('pt-BR')
  } catch {
    return dateStr
  }
}

export const ETAPA_LABELS: Record<string, string> = {
  REUNIAO_AGENDADA: 'Reunião Agendada',
  QUALIFICADO: 'Qualificado',
  PROPOSTA_ENVIADA: 'Proposta Enviada',
  NEGOCIACAO: 'Negociação',
  GANHO: 'Ganho',
  PERDIDO: 'Perdido',
}
